// extracted by mini-css-extract-plugin
module.exports = {"container":"DecisionHistoryLoading-container-97e50de17f0d7f822588649cefc8a3b7"};